import { buildVerificationColumns } from "@/components/agents/agent-verifications";
import { DataTable } from "@/components/ui/data-table";
import { createFileRoute, useLoaderData } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

/** `/agents/$slug/verifications` — Prokop's verdicts on the work items
 *  he tested. */
export const Route = createFileRoute("/_app/agents/$slug/verifications")({
  component: AgentVerifications,
});

function AgentVerifications() {
  const { t } = useTranslation();
  const data = useLoaderData({ from: "/_app/agents/$slug" });
  return (
    <DataTable
      columns={buildVerificationColumns(t)}
      rows={data.verifications ?? []}
      rowKey={(v) => v.id}
      rowTestId={() => "verification-row"}
      density="compact"
      emptyState={<span data-testid="verifications-empty">{t("agents.verifications.empty")}</span>}
    />
  );
}
